import { render, staticRenderFns } from "./selectPurchasingPlatform.vue?vue&type=template&id=61e6bbdd&scoped=true"
import script from "./selectPurchasingPlatform.vue?vue&type=script&lang=js"
export * from "./selectPurchasingPlatform.vue?vue&type=script&lang=js"
import style0 from "./selectPurchasingPlatform.vue?vue&type=style&index=0&id=61e6bbdd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.32_css-loader@6.11.0_webpack@5.105.4__lodash@4.18.1__yidcnbbritke6h73lk2rhpn7vi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e6bbdd",
  null
  
)

export default component.exports